import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Subject } from 'rxjs';

import { TelemetryService } from '../services/telemetry/telemetry.service';


@Injectable({providedIn: 'root'})
export class AppErrorHandler implements ErrorHandler {
	_events = new Subject()
	events$ = this._events.asObservable()

	constructor(private injector: Injector) {
	}

	handleError(error: any): void {
		this._events.next(error)
		try {
			const monitoringService = this.injector.get(TelemetryService);
			monitoringService.error(error);
		} catch (e) {
			console.warn(`[app] could not use telemetry`, e)
			console.warn(`[app] this is could happen with conflicting browser extensions like SeleniumIDE, Deepl or others`)
		}
		console.error(error);
	}
}
